export default __webpack_public_path__ + "static/media/Aegis of the Blood God.61940f22.jpg";